var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":"","dark":""}},[_c('line-chart',{attrs:{"chart-data":_vm.dataChart,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }